<style scoped>
    .vue-modal {
        display: block;
    }
</style>
<template>
    <div style="display: inline-block">
        <button
                class="btn btn-primary btn-sm"
                @click="getStickers()"
                :title="trans('show_stickers')"><i class="fa fa-image"></i>
        </button>
        <button
                class="btn btn-primary btn-sm"
                @click="getCustomDocuments()"
                :title="trans('show_custom_document')"><i class="fa fa-file-text"></i>
        </button>
        <button
                class="btn btn-primary btn-sm"
                @click="getManifest()"
                :title="trans('show_manifest')"
        >
            <i class="fa fa-file-pdf-o"></i>
        </button>
        <button
                class="btn btn-primary btn-sm"
                @click="showTariffChoiceModal()"
                :title="trans('show_registered_shipment_file')"><i class="fa fa-truck"></i>
        </button>
        <div class="modal vue-modal" v-show="show_delivery_tariffs">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" @click="show_delivery_tariffs = false" aria-label="Close">
                            <span aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title">{{trans('select_correos_tariffs')}}</h4>
                    </div>
                    <div class="modal-body">
                        <p class="lead text-mutted">
                            {{trans('select_correos_tariffs')}}
                        </p>
                        <select name="chosen_delivery_tariff" v-model="chosen_delivery_tariff" class="form-control">
                            <option v-for="tariff in correos_tariffs" :value="tariff.id">
                                {{tariff.name}}
                            </option>
                        </select>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-success pull-right" @click="printRegisterShipmentFile()"
                                style="margin-left: 15px;">Ok
                        </button>
                        <button type="button" class="btn btn-danger pull-right" @click="show_delivery_tariffs = false">
                            {{trans('cancel')}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as Functions from '../../Functions';

    export default {
        props: ['translations'],
        data: function () {
            return {
                checked: [],
                correos_tariffs: [],
                chosen_delivery_tariff: 0,
                show_delivery_tariffs: false,
                delivery_type_code: 'correos'
            };
        },
        mounted() {
            this.getDeliveryTariffs();
        },
        methods: {
            trans(name, path = 'print_controls') {
                return Functions.trans(this.translations, name, path);
            },
            getStickers: function () {
                if (this.checkLength()) {
                    return this.$parent.$options.methods.openWithPost('/shop/orders/print/stickers', {
                        ids: this.checked,
                        delivery_type_code: this.delivery_type_code
                    });
                }
            },
            getCustomDocuments: function () {
                if (this.checkLength()) {
                    return this.$parent.$options.methods.openWithPost('/shop/orders/print/custom_documents', {
                        ids: this.checked,
                        delivery_type_code: this.delivery_type_code
                    });
                }
            },
            getManifest: function () {
                if (this.checkLength()) {
                    return this.$parent.$options.methods.openWithPost('/shop/orders/print/manifest', {
                        ids: this.checked,
                        delivery_type_code: this.delivery_type_code
                    });
                }
            },
            showTariffChoiceModal: function () {
                this.show_delivery_tariffs = true;
            },
            printRegisterShipmentFile: function () {
                if (this.checkLength()) {
                    return this.$parent.$options.methods.openWithPost('/shop/orders/print/register_shipment_file', {
                        ids: this.checked,
                        delivery_type_code: this.delivery_type_code,
                        delivery_tariff_id: this.chosen_delivery_tariff
                    });
                }
            },
            checkLength: function () {
                if (this.checked.length < 1) {
                    alert(this.trans('orders_not_selected', null));
                    return false;
                }
                return true;
            },
            printParams: function () {
                return {
                    ids: this.checked,
                    delivery_type_code: this.delivery_type_code,
                    chosen_requisite: this.chosen_requisite
                }
            },
            getDeliveryTariffs() {
                this.$http.get(`/shop/deliveries/get_delivery_tariffs?delivery_type_code=${this.delivery_type_code}`)
                    .then(function (response) {
                        this.correos_tariffs = response.data;
                        this.chosen_delivery_tariff = this.correos_tariffs[0].id;
                    });
            }
        },
        created: function () {
            this.$root.$on('update:checked', (val) => {
                this.checked = val;
            });
        }
    }
</script>
